import { useMemo } from 'react';

import type { FormResponses, FormResult, SigninRequirements, SignoutRequirements } from '@sine/sine-core-api-types';

import { generateInitialFormValues } from '../helpers/formInitialization';
import generateSiteCheckInFormSchema from '../schemas/siteCheckInFormSchemas';

export function useCheckInOutForm(
  siteRequirements: SigninRequirements | SignoutRequirements | undefined,
  visitorTypeId: string,
  prefilledForm: FormResponses | FormResult | null | undefined,
  selectiveChoiceValues: Array<string> | undefined,
) {
  const formFieldsFilteredByVisitorType = useMemo(
    () => siteRequirements?.form?.fields.filter((field) => field.visitorTypes.includes(visitorTypeId)),
    [siteRequirements, visitorTypeId],
  );

  const { schema, initialValues } = useMemo(
    () => ({
      schema: generateSiteCheckInFormSchema(formFieldsFilteredByVisitorType, selectiveChoiceValues),
      initialValues: generateInitialFormValues(
        formFieldsFilteredByVisitorType,
        prefilledForm && 'responses' in prefilledForm ? prefilledForm.responses : undefined,
      ),
    }),
    [formFieldsFilteredByVisitorType, prefilledForm, selectiveChoiceValues],
  );

  return {
    formFieldsFilteredByVisitorType,
    schema,
    initialValues,
  };
}
